import router from "@/router";
import store from "@/store";

export default {
  methods: {
    createNotification(title, status, messages, callback) {
      const notification = {
        callback: callback,
        title: title,
        status: status,
        messages: messages,
      };
      store.commit("setNotification", notification);
    },

    onNotificationClose(status) {
      if (status == "success") {
        router.go(-1);
      }
    },
  },

  store,
};
